<template>
    <div class="order-detail-section mg20">
        <h3>合同信息</h3>
        <el-table :data="test" border style="margin:20px; width:97%">
            <el-table-column label="修订项" prop="title">
                <template slot-scope="scope">
                    {{scope.row.title}}
                </template>
            </el-table-column>
            <el-table-column label="修订后内容"  prop="ccc">
                <template slot-scope="scope">
                    <span v-html=scope.row.new_content></span>
                </template>
            </el-table-column>
            <el-table-column label="原内容" prop="bbb">
                <template slot-scope="scope" >
                    {{scope.row.old_content}}
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import {OrderMixin} from "~/services/OrderMixin";
    export default {
        name: "finance_contract",
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            oldOrder: {
                required: false
            }
        },
        watch: {
            order(v, s) {
                if(this.order.content){
                    if(this.$route.query['flow_type'] == this.params.CONTRACT_LINE){
                        this.order.content = this.order.order_detail.finance;
                    }
                    this.test = this.test.map(item=> {
                        if (item.field == 'total_amount') {
                            item.new_content = this.order.content.total_amount;
                            item.old_content = this.order.before_content.finance.total_amount;
                        }
                        if (item.field == 'contract_time') {
                            item.new_content = new Date(this.order.content.contract_time[0]).toLocaleDateString()+'~'+new Date(this.order.content.contract_time[1]).toLocaleDateString() ;
                            item.old_content = new Date(this.order.before_content.finance.contract_start_time*1000).toLocaleDateString()+'~'+new Date(this.order.before_content.finance.contract_end_time*1000).toLocaleDateString() ;
                        }
                        if (item.field == 'customer_sign_name') {
                            item.new_content = this.order.content.customer_sign_man;
                            item.old_content = this.order.before_content.finance.customer_sign_man;
                        }
                        if(item.new_content != item.old_content){
                            item.new_content = '<span style="color: red">'+item.new_content+'</span>'
                        }
                        return item;
                    });
                }
            }
        },
        mounted() {
            let params = {
                fields: 'id,name',
                scenario: 'all-user'
            };
        },
        data() {
            return {
                test:[
                    {
                        field:'total_amount',
                        title:'合同金额',
                        new_content:'',
                        old_content:'',
                    },
                    {
                        field:'contract_time',
                        title:'合同时间',
                        new_content:'',
                        old_content:'',
                    },
                    {
                        field:'customer_sign_name',
                        title:'客户签约人',
                        new_content:'',
                        old_content:'',
                    }
                ]
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/finance/finance_contract.vue